/**
* DOCUMENTO_CREDITO = holerite, extrato bancario, imposto de renda
* PROPOSTA = carta de crédito e outros documentos similares
* INCORPORADORAS_PROPOSTA_COMERCIAL = é um documento nao estruturado que autoriza ou não condiçoes especiais na compra de um imovel
*/

export enum StorageDocumentoTopicos {
    PROPOSTA = 0,
    DOCUMENTO_PESSOAL = 1,
    PROPOSTA_VISTORIA = 100,
    DOCUMENTO_CREDITO = 3,
    DOCUMENTO_VISTORIA = 4,
    DOCUMENTO_VENDEDOR = 5,
    DOCUMENTO_IMOVEL = 6,
    DOCUMENTO_FGTS = 7,
    DOCUMENTO_IQ = 8,
    DOCUMENTO_CONTRATO = 9,
    DOCUMENTO_SIMULACAO = 300,
}
